import { ApiManager } from 'utlis/api_manager';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);

export const MEMBER_ROLES = {
  ALL: 'all',
  OWNER: 'owner',
  EDITOR: 'editor',
  VIEW_ONLY: 'viewer',
  PENDING: 'pending',
};

export const getMembers = async ({
  workspaceUuid,
  search = '',
  role = MEMBER_ROLES.ALL,
  page = 1,
  pageSize = 20,
  ordering = 'name',
} = {}) => {
  const params = {
    page,
    page_size: pageSize,
    ordering,
  };

  if (search) {
    params.search = search;
  }

  if (role && role !== MEMBER_ROLES.ALL) {
    params.role = role;
  }

  const { data } = await api
    .setUrl(`project/team/workspaces/${workspaceUuid}/members`)
    .get(params);

  return data;
};

export const inviteMembers = async ({ workspaceUuid, emails, role }) => {
  const { data } = await api
    .setUrl(`project/team/workspaces/${workspaceUuid}/invitations`)
    .post({ emails, ...(role ? { role } : {}) });

  return data;
};

export const updateMemberRole = async ({ workspaceUuid, memberUuid, role }) => {
  const { data } = await api
    .setUrl(`project/team/workspaces/${workspaceUuid}/members/${memberUuid}`)
    .patch(null, { role });

  return data;
};

export const removeMember = async ({ workspaceUuid, memberUuid }) => {
  await api
    .setUrl(`project/team/workspaces/${workspaceUuid}/members/${memberUuid}`)
    .delete();
};

export const cancelInvitation = async ({ workspaceUuid, invitationUuid }) => {
  await api
    .setUrl(`project/team/workspaces/${workspaceUuid}/invitations/${invitationUuid}`)
    .delete();
};
